import React, { useContext, useEffect, useRef, useState } from 'react';

import InputControlRow from '../../../../ui/layout/InputControlRow';
import LeftRightSplit from '../../../../ui/LeftRightSplit';
import Select from '../../../../ui/Select';
import TextBox from '../../../../ui/TextBox';
import MultilineTextBox from '../../../../ui/MultilineTextBox';
import PrimaryButton from '../../../../ui/PrimaryButton';
import Date from '../../../../ui/Date';
import CheckBox from '../../../../ui/CheckBox';

import ApplicationContext from '../../../../ApplicationContext';
import useGlobalOkDialog from '../../../../hooks/useGlobalOkDialog';
import useFastStorage, { useTypedFastStorage } from '../../../../hooks/useFastStorage';
import useFunction from '../../../../hooks/useFunction';
import { now, nowDate } from '../../../../dateUtils';
import CloseButton from '../../../../ui/CloseButton';
import { getSQLInfoList } from '../../../../fms.core/data/TrackingModule';
import { TrackableEntity } from '../../../../fms.core/data/ChangeTrackable';
import { JobNames } from '../../../../framework.core/JobNames';
import { CodeGlNo } from '../../../../fms.core/CodeGlNo';
import { historyUpdate } from '../../../../fms.data/modules/FmsModFunc';
import { SQLField, SQLInfo, SQLType } from '../../../../framework.core/data/SQLInfo';
import { FmsSecTask } from '../../../../fms.core/constants';
import { findSecurityTask, getLayoutSizes } from '../../../../util';
import GlNoLookupField from '../../../../uiControls/lookup/GlNoLookupField';
import Float from '../../../../ui/Float';
import moment from 'moment';
import _ from 'lodash';
import RadioButton from '../../../../ui/RadioButton';
import { getFmsGlobal } from '../../../../globals';
import useGlobalYesNoDialog from '../../../../hooks/useGlobalYesNoDialog';
import useDirtyCheck from '../../../../hooks/useDirtyCheck2';
import { ArrivalReleaseNoticeViewModel } from '../../../../fms.core/report/ArrivalReleaseNoticeViewModel';
import GreenButton from '../../../../ui/GreenButton';
import useFunctionKeys from '../../../../hooks/useFunctionKeys';

let suntekId: string = '';
let isSuntekAdmin: boolean = false;

function RowSpacer_30() {
  return (
    <div style={{ height: '30px' }}>&nbsp;</div>
  );
}
function RowSpacer_40() {
  return (
    <div style={{ height: '40px' }}>&nbsp;</div>
  );
}
function RowSpacer_60() {
  return (
    <div style={{ height: '60px' }}>&nbsp;</div>
  );
}
const Groups = [
  { label: '1  ASSET', value: 'A', glNo: '1' },
  { label: '2  LIABILITY', value: 'L', glNo: '2' },
  { label: '3  EQUITY', value: 'Q', glNo: '3' },
  { label: '4  EXPENSE', value: 'E', glNo: '4' },
  { label: '5  SALES', value: 'I', glNo: '5', forFront: 'SALES' },
  { label: '6  COST', value: 'C', glNo: '6', forFront: 'COST' },
  // <chuck date="2024-04-01" desc="NON-OP EXPENSE/INCOME 에 대해 기존 숫자 체계는 유지하되 별도 Group으로 분리하는 작업">
  { label: '45 NON-OP EXPENSE', value: 'N', glNo: '4' },
  { label: '55 NON-OP INCOME', value: 'M', glNo: '5' },
  // </chuck>
];

let SubGroups1: Array<any> = [];

let SubGroups2: Array<any> = [];

function AccountCodeInitializedImpl({
  accountCode,
  onChange,
  cancelOperation,
  readonly,
  save,
  getFrontDesc,
}: {
  accountCode: CodeGlNo,
  onChange: (change: Partial<CodeGlNo>) => void,
  cancelOperation: () => boolean,
  readonly: boolean,
  save: () => Promise<void>,
  getFrontDesc: (accountCode: CodeGlNo, isInitialize?: boolean) => string
}) {


  const appContext = useContext(ApplicationContext);
  const isDefault = accountCode.isDefault;
  const checkSuntek = appContext.suntekSettings?.company?.companyId === "FSSUNTEK" || appContext.user?.isSuntekAdmin ? true : false;

  useEffect(() => {
    suntekId = appContext.suntekSettings?.company?.companyId?.toUpperCase() ?? '';
    isSuntekAdmin = appContext.user?.isSuntekAdmin ?? false;
    getSubGroup1Items(accountCode.glType);
    getSubGroup2Items(accountCode.glType, accountCode.glGroup)
    setLocalKey();
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  function getSubGroup1Items(group: string) {
    SubGroups1 = [];
    switch (group) {
      case "A":
        SubGroups1.push({ label: "1  CURRENT ASSET", value: "CA", glNo: "1" });
        SubGroups1.push({ label: "2  OTHER ASSET", value: "IA", glNo: "2" });
        SubGroups1.push({ label: "3  FIXED ASSET", value: "FA", glNo: "3" });
        break;
      case "L":
        SubGroups1.push({ label: "1  CURRENT LIABILITY", value: "CL", glNo: "1" });
        SubGroups1.push({ label: "2  NON-CURRENT LIABILITY", value: "NL", glNo: "2" });
        break;
      case "Q":
        SubGroups1.push({ label: "1  SHARE HOLDER'S EQUITY", value: "SQ", glNo: "1" });
        SubGroups1.push({ label: "2  CAPITAL SURPLUS", value: "CQ", glNo: "2" });
        SubGroups1.push({ label: "3  RETAINED EARNING", value: "NQ", glNo: "3" });
        break;
      case "E":
        SubGroups1.push({ label: "3  GENERAL EXPENSE", value: "GE", glNo: "3" });
        //SubGroups1.push({ label: "NON-OP EXPENSE", value: "OE", glNo: "5"});  // <chuck date="2024-04-01" desc="NON-OP EXPENSE/INCOME 에 대해 기존 숫자 체계는 유지하되 별도 Group으로 분리하는 작업" />
        SubGroups1.push({ label: "6  INCOME TAX", value: "TE", glNo: "6" });
        break;
      case "I":
        //SubGroups1.push({ label: "1  OCEAN IMPORT", value: "II", glNo: "1", extraCode: "OI" });
        //SubGroups1.push({ label: "1  OCEAN EXPORT", value: "EI", glNo: "1", extraCode: "OE" });
        //SubGroups1.push({ label: "2  AIR IMPORT", value: "AI", glNo: "2", extraCode: "AI" });
        //SubGroups1.push({ label: "2  AIR EXPORT", value: "PI", glNo: "2", extraCode: "AE" });
        //SubGroups1.push({ label: "3  OTHER SHIPMENT", value: "TI", glNo: "3", extraCode: "OTHR" });
        SubGroups1.push({ label: "4  WAREHOUSING", value: "WI", glNo: "4", extraCode: "WH" });
        SubGroups1.push({ label: "5  BROKERAGE TRUCKING", value: "RI", glNo: "5", extraCode: "OD" });
        //SubGroups1.push({ label: "NON-OP INCOME", value: "OI", glNo: "5", extraCode: ""});  // <chuck date="2024-04-01" desc="NON-OP EXPENSE/INCOME 에 대해 기존 숫자 체계는 유지하되 별도 Group으로 분리하는 작업" />
        if (suntekId === "FSSUNTEK") {
          SubGroups1.push({ label: "8  SUNTEK SALES", value: "TI", glNo: "8", extraCode: "" });
        }
        //SubGroups1.push({ label: "6  FULFILLMENT", value: "FF", glNo: "6", extraCode: "FF" });
        //SubGroups1.push({ label: "7  CHB", value: "CH", glNo: "7", extraCode: "CH" });

        break;
      case "C":
        //SubGroups1.push({ label: "1  OCEAN IMPORT", value: "IC", glNo: "1", extraCode: "OI" });
        //SubGroups1.push({ label: "1  OCEAN EXPORT", value: "EC", glNo: "1", extraCode: "OE" });
        //SubGroups1.push({ label: "2  AIR IMPORT", value: "AC", glNo: "2", extraCode: "AI" });
        //SubGroups1.push({ label: "2  AIR EXPORT", value: "PC", glNo: "2", extraCode: "AE" });
        //SubGroups1.push({ label: "3  OTHER SHIPMENT", value: "TC", glNo: "3", extraCode: "OTHR" });
        SubGroups1.push({ label: "4  WAREHOUSING", value: "WC", glNo: "4", extraCode: "WH" });
        if (suntekId === "FSSUNTEK") {
          SubGroups1.push({ label: "8  SUNTEK COST", value: "TC", glNo: "8", extraCode: "" });
        }
        //SubGroups1.push({ label: "6  FULFILLMENT", value: "FF", glNo: "6", extraCode: "FF" });
        //SubGroups1.push({ label: "7  CHB", value: "CH", glNo: "7", extraCode: "CH" });
        SubGroups1.push({ label: "5 BROKERAGE TRUCKING", value: "RC", glNo: "5", extraCode: "OD" });
        break;
      // <chuck date="2024-04-01" desc="NON-OP EXPENSE/INCOME 에 대해 기존 숫자 체계는 유지하되 별도 Group으로 분리하는 작업">
      case "N":
        SubGroups1.push({ label: "5  NON-OP EXPENSE", value: "OE", glNo: "5" });
        break;
      case "M":
        SubGroups1.push({ label: "5  NON-OP INCOME", value: "OI", glNo: "5", extraCode: "" });
        break;
      // </chuck>
    }
  }

  function getSubGroup2Items(group: string, subGroup1: string) {

    // + glSubGroup은 중복이 존재하고 있어서 기존 로직으론 문제가 있음. 유니크한 Key를 만들어 이를 value로 사용하게 수정.  chuck 2024-04-01

    SubGroups2 = [];
    if (group === "A") {
      switch (subGroup1) {
        case "CA":
          SubGroups2.push({ label: "1  QUICK ASSET", value: "QA1", glNo: "1", glCode: "QA" });
          SubGroups2.push({ label: "2  OTHER CURRENT ASSET", value: "CA2", glNo: "2", glCode: "CA" });
          break;
        case "IA":
          SubGroups2.push({ label: "1  OTHER ASSET", value: "OA1", glNo: "1", glCode: "OA" });
          break;
        case "FA":
          SubGroups2.push({ label: "1  TANGIBLE FIXED ASSET", value: "TA1", glNo: "1", glCode: "TA" });
          SubGroups2.push({ label: "2  INTANGIBLE FIXED ASSET", value: "GA2", glNo: "2", glCode: "GA" });
          SubGroups2.push({ label: "3  INVESTMENT", value: "IA3", glNo: "3", glCode: "IA" });
          break;
      }
    } else if (group === "L") {
      if (subGroup1 === "CL") {
        SubGroups2.push({ label: "1  CURRENT LIABILITY", value: "CL1", glNo: "1", glCode: "CL" });
        SubGroups2.push({ label: "2  OTHER CURRENCT LIABILITY", value: "OCL2", glNo: "2", glCode: "OCL" });
        if (isSuntekAdmin) {
          SubGroups2.push({ label: "5  CURRENT LIABILITY - Suntek", value: "CL5", glNo: "5", glCode: "CL" });
        }
      } else if (subGroup1 === "NL") {
        SubGroups2.push({ label: "1  NON-CURRENT LIABILITY", value: "NL1", glNo: "1", glCode: "NL" });
        SubGroups2.push({ label: "2  OTHER NON-CURRENCT LIABILITY", value: "ONL2", glNo: "2", glCode: "ONL" });
      }
    } else if (group === "Q") {
      switch (subGroup1) {
        case "SQ":
          SubGroups2.push({ label: "1  SHARE HOLDER'S EQUITY", value: "SQ1", glNo: "1", glCode: "SQ" });
          break;
        case "CQ":
          SubGroups2.push({ label: "1  CAPITAL SURPLUS", value: "CQ1", glNo: "1", glCode: "CQ" });
          break;
        case "NQ":
          SubGroups2.push({ label: "1  RETAINED EARNING", value: "NQ1", glNo: "1", glCode: "NQ" });
          SubGroups2.push({ label: "2  CAPITAL ADJUSTMENT", value: "AQ2", glNo: "2", glCode: "AQ2" });
          break;
      }
    } else if (group === "E") {
      switch (subGroup1) {
        case "GE":
          SubGroups2.push({ label: "1  GENERAL & ADMIN EXPENSE", value: "GE1", glNo: "1", glCode: "GE" });
          break;
        // <chuck date="2024-04-01" desc="NON-OP EXPENSE/INCOME 에 대해 기존 숫자 체계는 유지하되 별도 Group으로 분리하는 작업">
        // case "OE":
        //   SubGroups2.push({ label: "NON-OP EXPENSE", value: "OE", glNo: "1"});
        //   SubGroups2.push({ label: "TANGIBLE ASSET LOSS", value: "OE", glNo: "2"});
        //   SubGroups2.push({ label: "INTANGIBLE ASSET LOSS", value: "OE", glNo: "3"});
        //   SubGroups2.push({ label: "CORRECTION LOSS", value: "SE", glNo: "4"});
        //   break;
        // </chuck>
        case "TE":
          SubGroups2.push({ label: "1  FEDERAL", value: "IT1", glNo: "1", glCode: "IT" });
          SubGroups2.push({ label: "2  STATE", value: "IT2", glNo: "2", glCode: "IT" });
          break;
      }
    } else if (group === "I") {
      switch (subGroup1) {
        case "II":
          SubGroups2.push({ label: "1  DS", value: "DS1", glNo: "1", glCode: "DS" });
          SubGroups2.push({ label: "2  IDS", value: "IDS2", glNo: "2", glCode: "IDS" });
          SubGroups2.push({ label: "3  TS", value: "TS3", glNo: "3", glCode: "TS" });
          break;
        case "EI":
          SubGroups2.push({ label: "5  DS", value: "DS5", glNo: "5", glCode: "DS" });
          SubGroups2.push({ label: "6  IDS", value: "IDS6", glNo: "6", glCode: "IDS" });
          SubGroups2.push({ label: "7  TS", value: "TS7", glNo: "7", glCode: "TS" });
          break;
        case "AI":
          SubGroups2.push({ label: "1  DS", value: "DS1", glNo: "1", glCode: "DS" });
          SubGroups2.push({ label: "2  IDS", value: "IDS2", glNo: "2", glCode: "IDS" });
          SubGroups2.push({ label: "3  TS", value: "TS3", glNo: "3", glCode: "TS" });
          break;
        case "PI":
          SubGroups2.push({ label: "5  DS", value: "DS5", glNo: "5", glCode: "DS" });
          SubGroups2.push({ label: "6  IDS", value: "IDS6", glNo: "6", glCode: "IDS" });
          SubGroups2.push({ label: "7  TS", value: "TS7", glNo: "7", glCode: "TS" });
          break;
        case "TI":
          SubGroups2.push({ label: "1  DS", value: "DS1", glNo: "1", glCode: "DS" });
          SubGroups2.push({ label: "2  IDS", value: "IDS2", glNo: "2", glCode: "IDS" });
          SubGroups2.push({ label: "3  TS", value: "TS3", glNo: "3", glCode: "TS" });
          break;
        case "WI":
          SubGroups2.push({ label: "1  DS", value: "DS1", glNo: "1", glCode: "DS" });
          break;
        // <chuck date="2024-04-01" desc="NON-OP EXPENSE/INCOME 에 대해 기존 숫자 체계는 유지하되 별도 Group으로 분리하는 작업">
        // case "OI":
        //   SubGroups2.push({ label: "NON-OP INCOME", value: "OI", glNo: "1"});
        //   SubGroups2.push({ label: "TANGIBLE ASSET INCOME", value: "OI", glNo: "2"});
        //   SubGroups2.push({ label: "INTANGIBLE ASSET INCOME", value: "OI", glNo: "3"});
        //   SubGroups2.push({ label: "CORRECTION GAIN", value: "SI", glNo: "4"});
        //   break;
        // </chuck>
        case "FF":
          SubGroups2.push({ label: "1  DS", value: "DS1", glNo: "1", glCode: "DS" });
          break;
        case "CH":
          SubGroups2.push({ label: "1  DS", value: "DS1", glNo: "1", glCode: "DS" });
          break;
        case "RI":
          SubGroups2.push({ label: "1  DS", value: "DS1", glNo: "1", glCode: "DS" });
          break;
      }
    } else if (group === "C") {
      switch (subGroup1) {
        case "IC":
          SubGroups2.push({ label: "1  DS", value: "DS1", glNo: "1", glCode: "DS" });
          SubGroups2.push({ label: "2  IDS", value: "IDS2", glNo: "2", glCode: "IDS" });
          SubGroups2.push({ label: "3  TS", value: "TS3", glNo: "3", glCode: "TS" });
          break;
        case "EC":
          SubGroups2.push({ label: "5  DS", value: "DS5", glNo: "5", glCode: "DS" });
          SubGroups2.push({ label: "6  IDS", value: "IDS6", glNo: "6", glCode: "IDS" });
          SubGroups2.push({ label: "7  TS", value: "TS7", glNo: "7", glCode: "TS" });
          break;
        case "AC":
          SubGroups2.push({ label: "1  DS", value: "DS1", glNo: "1", glCode: "DS" });
          SubGroups2.push({ label: "2  IDS", value: "IDS2", glNo: "2", glCode: "IDS" });
          SubGroups2.push({ label: "3  TS", value: "TS3", glNo: "3", glCode: "TS" });
          break;
        case "PC":
          SubGroups2.push({ label: "5  DS", value: "DS5", glNo: "5", glCode: "DS" });
          SubGroups2.push({ label: "6  IDS", value: "IDS6", glNo: "6", glCode: "IDS" });
          SubGroups2.push({ label: "7  TS", value: "TS7", glNo: "7", glCode: "TS" });
          break;
        case "TC":
          SubGroups2.push({ label: "1  DS", value: "DS1", glNo: "1", glCode: "DS" });
          SubGroups2.push({ label: "2  IDS", value: "IDS2", glNo: "2", glCode: "IDS" });
          SubGroups2.push({ label: "3  TS", value: "TS3", glNo: "3", glCode: "TS" });
          break;
        case "WC":
          SubGroups2.push({ label: "1  DS", value: "DS1", glNo: "1", glCode: "DS" });
          break;
        case "FF":
          SubGroups2.push({ label: "1  DS", value: "DS1", glNo: "1", glCode: "DS" });
          break;
        case "CH":
          SubGroups2.push({ label: "1  DS", value: "DS1", glNo: "1", glCode: "DS" });
          break;
        case "RC":
          SubGroups2.push({ label: "1  DS", value: "DS1", glNo: "1", glCode: "DS" });
          break;
      }
      // <chuck date="2024-04-01" desc="NON-OP EXPENSE/INCOME 에 대해 기존 숫자 체계는 유지하되 별도 Group으로 분리하는 작업">
    } else if (group === "N") {
      switch (subGroup1) {
        case "OE":
          SubGroups2.push({ label: "1  NON-OP EXPENSE", value: "OE1", glNo: "1", glCode: "OE" });
          SubGroups2.push({ label: "2  TANGIBLE ASSET LOSS", value: "OE2", glNo: "2", glCode: "OE" });
          SubGroups2.push({ label: "3  INTANGIBLE ASSET LOSS", value: "OE3", glNo: "3", glCode: "OE" });
          SubGroups2.push({ label: "4  CORRECTION LOSS", value: "SE4", glNo: "4", glCode: "SE" });
          break;
      }
    } else if (group === "M") {
      switch (subGroup1) {
        case "OI":
          SubGroups2.push({ label: "1  NON-OP INCOME", value: "OI1", glNo: "1", glCode: "OI" });
          SubGroups2.push({ label: "2  TANGIBLE ASSET INCOME", value: "OI2", glNo: "2", glCode: "OI" });
          SubGroups2.push({ label: "3  INTANGIBLE ASSET INCOME", value: "OI3", glNo: "3", glCode: "OI" });
          SubGroups2.push({ label: "4  CORRECTION GAIN", value: "SI4", glNo: "4", glCode: "SI" });
          break;
      }
    }
    // </chuck>
  }

  function setFrontDescription() {
    if (accountCode.glType !== "I" && accountCode.glType !== "C") return;
    const frontDesc = getFrontDesc(accountCode);
    onChange({ frontGlDesc: frontDesc, frontLocalDesc: frontDesc })
  }

  function setLocalKey() {
    const glTypeKey = accountCode.glType + accountCode.glNo0;
    const glGroupKey = accountCode.glGroup + accountCode.glNo1;
    const glSubGroupKey = accountCode.glSubGroup + accountCode.glNo2;
    onChange({ glTypeText: glTypeKey, glGroupText: glGroupKey, glSubGroupText: glSubGroupKey });
  }

  function setExistingCode() {
    let code = accountCode.glNo0 + accountCode.glNo1 + accountCode.glNo2 + (accountCode.glNo3 || '') + (accountCode.glNo4 || '') + (accountCode.glNo5 || '');
    onChange({ existingCode: code });
    if (accountCode.glType === 'I') {
      let costCode = 6 + accountCode.glNo1 + accountCode.glNo2 + (accountCode.glNo3 || '') + (accountCode.glNo4 || '') + (accountCode.glNo5 || '');
      onChange({ otherExistingCode: costCode });
    } else if (accountCode.glType === 'C') {
      let costCode = 5 + accountCode.glNo1 + accountCode.glNo2 + (accountCode.glNo3 || '') + (accountCode.glNo4 || '') + (accountCode.glNo5 || '');
      onChange({ otherExistingCode: costCode });
    }
  }

  function setAccountCodeText() {
    switch (accountCode.glType) {
      case 'A':
        return 'Asset';
      case 'L':
        return 'Liability';
      case 'Q':
        return 'Equity';
      case 'E':
        return 'Expense';
      case 'I':
        return 'Sales';
      case 'C':
        return 'Cost';
      case 'N':
        return 'Non-OP-Expense';
      case 'M':
        return 'Non-OP-Income';
      default:
        return '';
    }
  }

  function onlySuntekField() {
    return (
      <>
        {checkSuntek &&
          <>
            <InputControlRow label="✱ Suntek Internal Use Only" bold customFontSize='12px'>
              <div style={{ marginLeft: '15px' }}>
                <RadioButton group="accountCode-paymentOption" reverse label="Not Use"
                  checked={!accountCode?.useOnBillPay && !accountCode?.useOnCustPay} boldOnActive disabled={readonly}
                  onChecked={() => onChange({ useOnBillPay: false, useOnCustPay: false, custPayShowOption: '', billPayShowOption: '' })} />
              </div>
              <div style={{ marginLeft: '15px' }}>
                <RadioButton group="accountCode-paymentOption" reverse label="Show Code in Bill Pay (Non-OP Tab)"
                  checked={accountCode?.useOnBillPay} boldOnActive disabled={readonly}
                  onChecked={() => onChange({ useOnBillPay: true, useOnCustPay: false, custPayShowOption: '' })} />
              </div>
              <div style={{ marginLeft: '15px' }}>
                <RadioButton group="accountCode-paymentOption" reverse label="Show Code in Customer Pay (Non-OP Tab)"
                  checked={accountCode?.useOnCustPay} boldOnActive disabled={readonly}
                  onChecked={() => onChange({ useOnCustPay: true, useOnBillPay: false, billPayShowOption: '' })} />
              </div>
            </InputControlRow>
          </>
        }
      </>
    );
  }

  function redioChanged(glType: string) {
    const item = Groups.find(x => x.value === glType);
    const mainChange: Partial<CodeGlNo> = {
      glType: glType, glGroup: '', glSubGroup: '',
      glNo0: item?.glNo, glNo1: '', glNo2: '', glNo3: '', glNo4: '', glNo5: ''
    };
    if (glType !== "I" && glType !== "C") {
      mainChange.frontGlDesc = '';
      mainChange.frontLocalDesc = '';
    }
    getSubGroup1Items(glType);
    // <chuck date="2022-10-13" desc="if there is only one, it is automatically selected">
    if (SubGroups1.length === 1) {
      mainChange.glGroup = SubGroups1[0].value;
      mainChange.glNo1 = SubGroups1[0].glNo;
      getSubGroup2Items(glType, SubGroups1[0].value);
    } else {
      mainChange.glGroup = '';
      mainChange.glSubGroupText = '';
    }
    // </chuck>
    onChange(mainChange);
    setExistingCode();
    getSubGroup1Items(accountCode.glType);
    setFrontDescription();
  }

  function otherSalesCostView(isSalesDetail: boolean) { //Sales나 Cost를 선택했을 경우 선택하지 않은 쪽을 보여주기 위함 1. GlNo를 입력할수 없고 2. 
    let glNo0 = isSalesDetail ? 5 : 6;

    return (
      <>
        <div style={{ width: '280px', float: 'left', marginRight: '45px' }}>
          <InputControlRow label="✱ Check Existing Account Code Look-up" bold customFontSize='12px'>
            <div style={{ marginLeft: '15px' }}> (if No Look-up Table Show, It is OK.)</div>
            <div style={{ width: '100px', marginLeft: '15px' }}>
              <GlNoLookupField
                name='biilingCode-direct-costCode'
                maxLength={10}
                disabled={readonly || (!checkSuntek && isDefault)}
                filterName='code'
                searchStartWith={true}
                initialValue={accountCode.otherExistingCode}
                onSelect={select => onChange({ otherExistingCode: select.code })}
              />
            </div>
          </InputControlRow>
          <RowSpacer_30 />
          <InputControlRow label={<span>{isSalesDetail ? '4' : '7'}. Enter <span style={{ color: 'blue' }}>{isSalesDetail ? 'Sales' : 'Cost'}</span> Account Code (4/5/6th Digits)</span>} bold customFontSize='12px'>
            <div style={{ marginLeft: '12px' }}>
              <div style={{ float: 'left', width: '35px' }}>1st</div>
              <div style={{ float: 'left', width: '35px' }}>2nd</div>
              <div style={{ float: 'left', width: '35px' }}>3rd</div>
              <div style={{ float: 'left', width: '35px' }}>4th</div>
              <div style={{ float: 'left', width: '35px' }}>5th</div>
              <div style={{ float: 'left', width: '35px' }}>6th</div>
              <div style={{ clear: 'both' }}></div>
            </div>
            <div style={{ marginLeft: '12px' }}>
              <div style={{ float: 'left', width: '35px' }}><Float min={0} max={9} value={glNo0} disabled style={{ paddingRight: '13px' }} decimals={0} /></div>
              <div style={{ float: 'left', width: '35px' }}><Float min={0} max={9} value={parseInt(accountCode.glNo1)} disabled style={{ paddingRight: '13px' }} decimals={0} /></div>
              <div style={{ float: 'left', width: '35px' }}><Float min={0} max={9} value={parseInt(accountCode.glNo2)} disabled style={{ paddingRight: '13px' }} decimals={0} /></div>
              <div style={{ float: 'left', width: '35px' }}><Float min={0} max={9} value={parseInt(accountCode.glNo3)} disabled style={{ paddingRight: '13px' }} decimals={0} /></div>
              <div style={{ float: 'left', width: '35px' }}><Float min={0} max={9} value={parseInt(accountCode.glNo4)} disabled style={{ paddingRight: '13px' }} decimals={0} /></div>
              <div style={{ float: 'left', width: '35px' }}><Float min={0} max={9} value={parseInt(accountCode.glNo5)} disabled style={{ paddingRight: '13px' }} decimals={0} /></div>
              <div style={{ clear: 'both' }}></div>
            </div>
          </InputControlRow>
          <RowSpacer_40 />
          <InputControlRow label={`${isSalesDetail ? '5' : '8'}. Account Code Name`} bold customFontSize='12px'>
            <div style={{ marginLeft: '15px' }}>
              <TextBox name='accountcode-name' maxLength={100} disabled={readonly || (!checkSuntek && isDefault)} value={accountCode.otherdisplayDesc || ''}
                placeholder={' Enter Your Account Code Name'}
                onChange={e => onChange({
                  otherGlDesc: e.target.value, otherdisplayDesc: e.target.value, otherLocalDesc: e.target.value, otherdisplayLocalDesc: e.target.value
                })} />
            </div>
          </InputControlRow>
          <RowSpacer_30 />
          <InputControlRow label={`${isSalesDetail ? '6' : '9'}. Account Code Name (Customized)`} bold customFontSize='12px'>
            <div style={{ marginLeft: '15px' }}>
              <TextBox name='accountCode-CustomName' maxLength={50} disabled={readonly} value={accountCode.otherdisplayLocalDesc || ''}
                onChange={e => onChange({ otherLocalDesc: e.target.value, otherdisplayLocalDesc: e.target.value })}
                placeholder={' Enter Your Own Custom Account Code Name'} />
            </div>
          </InputControlRow>
          <RowSpacer_30 />
          <InputControlRow label="✱ Remark" bold customFontSize='12px'>
            <div style={{ marginLeft: '15px' }}>
              <MultilineTextBox name='accountcode-remark' maxLength={300} style={{ height: '50px' }} disabled={readonly || (!checkSuntek && isDefault)} value={accountCode.otherRemark || ''} onChange={e => onChange({ otherRemark: e.target.value })} />
            </div>
          </InputControlRow>
          <RowSpacer_60 />
          {isSalesDetail && onlySuntekField()}
        </div>
      </>
    );
  }

  function inactive() {

    return (
      <>
        <div>
          <LeftRightSplit
            leftSize="calc(100% - 120px)"
            rightSize="120px"
            left={
              <div style={{ marginRight: '50px', position: 'relative' }}>
                <InputControlRow
                  label={
                    <LeftRightSplit
                      leftSize="30px"
                      rightSize="calc(100% - 30px)"
                      left={
                        <CheckBox focusId='accountCode-chk-inactive' disabled={!checkSuntek || readonly || (!checkSuntek && isDefault)} value={accountCode?.inactive || false}
                          onChange={
                            inactive => onChange({
                              inactive,
                              inactiveDate: inactive ? now() : null,
                              inactiveBy: inactive ? appContext.user?.id ?? '' : ''
                            })} />
                      }
                      right={<>Inactive</>}
                    />
                  }
                >
                  <Date dateId='accountCode-inactiveDate' disabled value={accountCode?.inactiveDate} />
                </InputControlRow>
              </div>
            }
            right={
              <InputControlRow label="By">
                <TextBox textId='accountCode-inactiveBy' disabled value={accountCode?.inactiveBy || ''} />
              </InputControlRow>
            }
          />
        </div>
      </>
    );
  }

  return (
    <div style={{ minHeight: '350px' }}>
      <div className="oi-doc-details-row" style={{ paddingLeft: '40px' }}>
        <div style={{ width: '250px', float: 'left', marginRight: '45px' }}>
          <InputControlRow label="1. Group for 1st Digit" bold customFontSize='12px'>
            <div style={{ marginLeft: '15px' }}>
              <div style={{ float: 'left', width: '100%' }}>
                <RadioButton radioId='accountcode-gltype-A' reverse label="1.  ASSET" disabled={readonly || (!checkSuntek && isDefault)} checked={accountCode.glType === 'A'}
                  onChecked={() => { redioChanged('A'); }} />
              </div>
              <div style={{ float: 'left', width: '100%' }}>
                <RadioButton radioId='accountcode-gltype-L' reverse label="2.  LIABILITY" disabled={readonly || (!checkSuntek && isDefault)} checked={accountCode.glType === 'L'}
                  onChecked={() => { redioChanged('L'); }} />
              </div>
              <div style={{ float: 'left', width: '100%' }}>
                <RadioButton radioId='accountcode-gltype-Q' reverse label="3.  EQUITY" disabled={readonly || (!checkSuntek && isDefault)} checked={accountCode.glType === 'Q'}
                  onChecked={() => { redioChanged('Q'); }} />
              </div>
              <div style={{ float: 'left', width: '100%' }}>
                <RadioButton radioId='accountcode-gltype-E' reverse label="4.  EXPENSE" disabled={readonly || (!checkSuntek && isDefault)} checked={accountCode.glType === 'E'}
                  onChecked={() => { redioChanged('E'); }} />
              </div>
              <div style={{ clear: 'both' }}></div>
              <div style={{ float: 'left', width: '100%' }}>
                <RadioButton radioId='accountcode-gltype-I' reverse label="5.  SALES" disabled={readonly || (!checkSuntek && isDefault)} checked={accountCode.glType === 'I'}
                  onChecked={() => { redioChanged('I'); }} />
              </div>
              <div style={{ float: 'left', width: '100%' }}>
                <RadioButton radioId='accountcode-gltype-C' reverse label="6.  COST" disabled={readonly || (!checkSuntek && isDefault)} checked={accountCode.glType === 'C'}
                  onChecked={() => { redioChanged('C'); }} />
              </div>
              <div style={{ float: 'left', width: '100%' }}>
                <RadioButton radioId='accountcode-gltype-N' reverse label="45. NON-OP EXPENSE" disabled={readonly || (!checkSuntek && isDefault)} checked={accountCode.glType === 'N'}
                  onChecked={() => { redioChanged('N'); }} />
              </div>
              <div style={{ float: 'left', width: '100%' }}>
                <RadioButton radioId='accountcode-gltype-M' reverse label="55. NON-OP INCOME" disabled={readonly || (!checkSuntek && isDefault)} checked={accountCode.glType === 'M'}
                  onChecked={() => { redioChanged('M'); }} />
              </div>
              <div style={{ clear: 'both' }}></div>
            </div>
          </InputControlRow>
          <div style={{ clear: 'both' }}></div>
          <div style={{ height: '36px' }}></div>
          <InputControlRow label="2. Sub Group 1 for 2nd Digit" bold customFontSize='12px'>
            <div style={{ marginLeft: '15px' }}>
              <Select selectId='accountcode-glgroup' name='accountcode-glgroup' disabled={readonly || !accountCode.glType || (!checkSuntek && isDefault)} items={SubGroups1} value={accountCode.glGroup || ''} useBlank={true}
                placeholder={SubGroups1[0]?.label ?? '1  CURRENT ASSET'}
                onChange={e => {
                  const item = SubGroups1.find(x => x.value === e.target.value);
                  // <chuck date="2022-10-13" desc="if there is only one, it is automatically selected">
                  //onChange({ glGroup: e.target.value, glSubGroup: '', glNo1: item?.glNo, glNo2: '' });
                  //getSubGroup2Items(accountCode.glType, accountCode.glGroup);
                  const mainChange: Partial<CodeGlNo> = { glGroup: e.target.value, glSubGroup: '', glNo1: item?.glNo, glNo2: '' };

                  getSubGroup2Items(accountCode.glType, e.target.value);
                  if (SubGroups2.length === 1) {
                    mainChange.glSubGroup = SubGroups2[0].glCode;
                    mainChange.glSubGroupText = SubGroups2[0].value;
                    mainChange.glNo2 = SubGroups2[0].glNo;
                  } else {
                    mainChange.glSubGroup = '';
                    mainChange.glSubGroupText = '';
                  }
                  onChange(mainChange);
                  // </chuck>

                  setExistingCode();
                  setFrontDescription();
                }}
              />
            </div>
          </InputControlRow>
          <RowSpacer_30 />
          <InputControlRow label="3. Sub Group 2 for 3rd Digit" bold customFontSize='12px'>
            <div style={{ marginLeft: '15px' }}>
              {
                !(accountCode.glType === 'C' || accountCode.glType === 'I') &&
                <Select name='accountcode-glsubgroup' disabled={readonly || !accountCode.glGroup || (!checkSuntek && isDefault)} items={SubGroups2} value={accountCode.glSubGroupText || ''} useBlank={true}
                  placeholder={SubGroups2[0]?.label ?? '1  QUICK ASSET'}
                  onChange={e => {
                    const item = SubGroups2.find(x => x.value === e.target.value);
                    onChange({ glSubGroup: item?.glCode, glSubGroupText: e.target.value, glNo2: item?.glNo });
                    setExistingCode();
                    setFrontDescription();
                  }}
                />
              }
              {
                (accountCode.glType === 'C' || accountCode.glType === 'I') &&
                <div>
                  <div>
                    <div style={{ float: 'left', width: '33%' }}>
                      <RadioButton radioId='accountcode-glsubgroup-DS' reverse label="DS" disabled={readonly || !accountCode.glGroup || (!checkSuntek && isDefault)}
                        checked={accountCode?.glSubGroup === 'DS'}
                        onChecked={() => {
                          const item = SubGroups2.find(x => x.glCode === 'DS');
                          onChange({ glSubGroup: item?.glCode, glSubGroupText: 'DS', glNo2: item?.glNo });
                          setExistingCode();
                          setFrontDescription();
                        }
                        } />
                    </div>
                    {
                      accountCode.glGroup !== 'FF' && accountCode.glGroup !== 'CH' && accountCode.glGroup !== 'WI' && accountCode.glGroup !== 'WC' && accountCode.glGroup !== 'RI' && accountCode.glGroup !== 'RC' &&
                      <div style={{ float: 'left', width: '33%' }}>
                        <RadioButton radioId='accountcode-glsubgroup-IDS' reverse label="IDS" disabled={readonly || !accountCode.glGroup || (!checkSuntek && isDefault)}
                          checked={accountCode?.glSubGroup === 'IDS'}
                          onChecked={() => {
                            const item = SubGroups2.find(x => x.glCode === 'IDS');
                            onChange({ glSubGroup: item?.glCode, glSubGroupText: 'IDS', glNo2: item?.glNo });
                            setExistingCode();
                            setFrontDescription();
                          }
                          } />
                      </div>
                    }
                    {
                      accountCode.glGroup !== 'FF' && accountCode.glGroup !== 'CH' && accountCode.glGroup !== 'WI' && accountCode.glGroup !== 'WC' && accountCode.glGroup !== 'RI' && accountCode.glGroup !== 'RC'  &&
                      <div style={{ float: 'left', width: '33%' }}>
                        <RadioButton radioId='accountcode-glsubgroup-TS' reverse label="TS" disabled={readonly || !accountCode.glGroup || (!checkSuntek && isDefault)}
                          checked={accountCode?.glSubGroup === 'TS'}
                          onChecked={() => {
                            const item = SubGroups2.find(x => x.glCode === 'TS');
                            onChange({ glSubGroup: item?.glCode, glSubGroupText: 'TS', glNo2: item?.glNo });
                            setExistingCode();
                            setFrontDescription();
                          }
                          } />
                      </div>
                    }
                    <div style={{ clear: 'both' }}></div>
                  </div>
                </div>
              }
            </div>
          </InputControlRow>

        </div>
        {accountCode.glType === 'C' &&
          //Cost일때 나타나는 Sales창
          otherSalesCostView(true)
        }

        <div style={{ width: '280px', float: 'left', marginRight: '45px' }}>
          <InputControlRow label="✱ Check Existing Account Code Look-up" bold customFontSize='12px'>
            <div style={{ marginLeft: '15px' }}> (if No Look-up Table Show, It is OK.)</div>
            <div style={{ width: '100px', marginLeft: '15px' }}>
              <GlNoLookupField
                name='biilingCode-direct-costCode'
                maxLength={10}
                disabled={readonly || (!checkSuntek && isDefault)}
                filterName='code'
                searchStartWith={true}
                initialValue={accountCode.existingCode}
                onSelect={select => onChange({ existingCode: select.code })}
              />
            </div>
          </InputControlRow>
          <RowSpacer_30 />
          <div style={{ whiteSpace: 'nowrap' }}>
            <InputControlRow label={<span>{accountCode.glType === 'C' ? '7' : '4'}. Enter <span style={{ color: 'blue' }}>{setAccountCodeText()}</span> Account Code (4/5/6th Digits)</span>} bold customFontSize='12px'>
              <div style={{ marginLeft: '12px' }}>
                <div style={{ float: 'left', width: '35px' }}>1st</div>
                <div style={{ float: 'left', width: '35px' }}>2nd</div>
                <div style={{ float: 'left', width: '35px' }}>3rd</div>
                <div style={{ float: 'left', width: '35px' }}>4th</div>
                <div style={{ float: 'left', width: '35px' }}>5th</div>
                <div style={{ float: 'left', width: '35px' }}>6th</div>
                <div style={{ clear: 'both' }}></div>
              </div>
              <div style={{ marginLeft: '12px' }}>
                <div style={{ float: 'left', width: '35px' }}><Float min={0} max={9} value={parseInt(accountCode.glNo0)} disabled style={{ paddingRight: '13px' }} decimals={0} /></div>
                <div style={{ float: 'left', width: '35px' }}><Float min={0} max={9} value={parseInt(accountCode.glNo1)} disabled style={{ paddingRight: '13px' }} decimals={0} /></div>
                <div style={{ float: 'left', width: '35px' }}><Float min={0} max={9} value={parseInt(accountCode.glNo2)} disabled style={{ paddingRight: '13px' }} decimals={0} /></div>
                <div style={{ float: 'left', width: '35px' }}><Float name='accountcode-glno3' min={0} max={9} value={parseInt(accountCode.glNo3)} disabled={readonly || (!checkSuntek && isDefault)}
                  onChange={glNo3 => {
                    onChange({ glNo3: glNo3?.toString() });
                    if (!glNo3) onChange({ glNo4: '', glNo5: '' }); setExistingCode();
                  }} style={{ paddingRight: '13px' }} decimals={0} /></div>
                <div style={{ float: 'left', width: '35px' }}>
                  <Float name='accountcode-glno4' min={0} max={9} value={parseInt(accountCode.glNo4)} disabled={readonly || (!checkSuntek && isDefault)}
                    onChange={glNo4 => {
                      onChange({ glNo4: glNo4?.toString() });
                      if (!glNo4) onChange({ glNo5: '' }); setExistingCode();
                    }} style={{ paddingRight: '13px' }} decimals={0} /></div>
                <div style={{ float: 'left', width: '35px' }}>
                  <Float name='accountcode-glno5' min={0} max={9} value={parseInt(accountCode.glNo5)} disabled={readonly || (!checkSuntek && isDefault)}
                    onChange={glNo5 => { onChange({ glNo5: glNo5?.toString() }); setExistingCode(); }} style={{ paddingRight: '13px' }} decimals={0} /></div>
                <div style={{ clear: 'both' }}></div>
              </div>
            </InputControlRow>
          </div>
          <RowSpacer_40 />
          <InputControlRow label={accountCode.glType === 'C' ? '8. Account Code Name' : '5. Account Code Name'} bold customFontSize='12px'>
            <div style={{ marginLeft: '15px' }}>
              <TextBox name='accountcode-name' maxLength={100} disabled={readonly || (!checkSuntek && isDefault)} value={accountCode.displayDesc || ''}
                placeholder={' Enter Your Account Code Name'}
                onChange={e => onChange({ displayDesc: e.target.value, glDescription: e.target.value })}
                onBlur={() => {
                  if (accountCode.displayLocalDesc === '') {
                    onChange({ displayLocalDesc: accountCode.displayDesc, localDesc: accountCode.displayDesc })
                  }
                  if (accountCode.otherdisplayDesc === '') onChange({ 
                    otherGlDesc: accountCode.glDescription, otherdisplayDesc: accountCode.displayDesc , 
                    otherdisplayLocalDesc:accountCode.displayDesc});
                }} />
            </div>
          </InputControlRow>
          <RowSpacer_30 />
          <InputControlRow label={accountCode.glType === 'C' ? '9. Account Code Name (Customized)' : '6. Account Code Name (Customized)'} bold customFontSize='12px'>
            <div style={{ marginLeft: '15px' }}>
              <TextBox name='accountCode-CustomName' maxLength={50} disabled={readonly} value={accountCode.displayLocalDesc || ''}
                onChange={e => onChange({ displayLocalDesc: e.target.value, localDesc: e.target.value })}
                onBlur={() => { if (!accountCode.otherdisplayLocalDesc) onChange({ otherLocalDesc: accountCode.displayLocalDesc, otherdisplayLocalDesc: accountCode.displayLocalDesc }) }}
                placeholder={' Enter Your Own Custom Account Code Name'} />
            </div>
          </InputControlRow>
          <RowSpacer_30 />
          {(accountCode.glType === 'C' || accountCode.glType === 'I') &&
            <div>
              <InputControlRow label="✱ Remark" bold customFontSize='12px'>
                <div style={{ marginLeft: '15px' }}>
                  <MultilineTextBox name='accountcode-remark' maxLength={300} style={{ height: '50px' }} disabled={readonly || (!checkSuntek && isDefault)} value={accountCode.remark || ''} onChange={e => onChange({ remark: e.target.value })} />
                </div>
              </InputControlRow>
              <RowSpacer_60 />
            </div>
          }
          {accountCode.glType === 'I' &&
            onlySuntekField()
          }
          {accountCode.glType === 'C' && checkSuntek &&
            inactive()
          }
        </div>

        {accountCode.glType !== 'C' &&
          <div style={{ width: '280px', float: 'left', marginRight: '45px' }}>
            <div style={{ height: '410px' }}>
              {accountCode.glType === 'I' &&
                otherSalesCostView(false)
              }
              {accountCode.glType !== 'I' &&
                <div>
                  <InputControlRow label="✱ Remark" bold customFontSize='12px'>
                    <div style={{ marginLeft: '15px' }}>
                      <MultilineTextBox name='accountcode-remark' maxLength={300} style={{ height: '50px' }} disabled={readonly || (!checkSuntek && isDefault)} value={accountCode.remark || ''} onChange={e => onChange({ remark: e.target.value })} />
                    </div>
                  </InputControlRow>
                  <RowSpacer_60 />
                </div>
              }
              {accountCode.glType !== 'I' &&
                onlySuntekField()
              }
            </div>
            {checkSuntek &&
              inactive()
            }
          </div>
        }
      </div>
    </div>
  );
}

function AccountCodeDetails({
  accountCodeT,
  reload,
  cancelOperation,
  checkSuntek
}: {
  accountCodeT: CodeGlNo,
  reload: (clearAll?: boolean) => Promise<void>,
  cancelOperation: any,
  checkSuntek:boolean
}) {
  useFunction({
    invokers: {
      ifmsSettingsSave: save,
      ifmsSettingsCancel: cancelOperation,
    }
  });
  useFunctionKeys({ onSave: handleSaveAndClose });

  const fmsGlobal = getFmsGlobal();
  const appContext = useContext(ApplicationContext);

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  const [accountCode, _setAccountCode, removeAccountCodeFromStorage, accountCodeRef] = useTypedFastStorage<CodeGlNo>(`ifms-referenceFiles-accountcode-editable`, null);
  const { setCleanState } = useDirtyCheck(`ifms-referenceFiles-accountcode-editable`, ['edit', 'view']);
  const [, setHasChanges] = useFastStorage(`ifms-referenceFiles-haschanges`, false);

  const listSec = findSecurityTask(appContext, FmsSecTask.CodeAccountCode);

  useEffect(() => {
    initialize();
  }, []);

  function handleSaveAndClose() {
    const saveBtn = document.getElementById('detail-save-button');
    if (saveBtn) {
      saveBtn.focus();
      const modals = document.querySelectorAll('[class^="ReactModal__Content"]');
      const modalsWithoutSaveBtn = Array.from(modals).filter(modal => { return !modal.contains(saveBtn); });
      if (modalsWithoutSaveBtn.length <= 0)
        saveBtn.click();
    }
  }

  async function initialize() {
    setAccountCode(accountCodeT);
  }

  function setAccountCode(d: any, skipDirty: boolean = false) {
    if (!skipDirty) {
      setHasChanges(true);
    }
    _setAccountCode(d)
  }

  function getFrontDesc(accountCode: CodeGlNo, isInitialize: boolean = false): string {
    if (accountCode.glType !== "I" && accountCode.glType !== "C") return '';

    let frontDesc = '';
    if (isInitialize) {
      let splitDesc = accountCode.glDescription.split('.');
      frontDesc = splitDesc[0] + '.' + splitDesc[1] + '.' + splitDesc[2] + '.';
    }
    else {
      let desc = Groups?.find(x => x.value === accountCode.glType)?.forFront ?? '';
      if (desc) frontDesc += desc + '.';
      desc = SubGroups1?.find(x => x.value === accountCode.glGroup)?.extraCode ?? '';
      if (desc) frontDesc += desc + '.';
      if (accountCode.glSubGroup) frontDesc += accountCode.glSubGroup + '.';
    }
    return frontDesc;
  }

  async function checkDataAsync(): Promise<boolean> {
    if (!accountCode) {
      return true;
    }

    const glNo = accountCode.glNo0 + accountCode.glNo1 + accountCode.glNo2 + accountCode.glNo3 + accountCode.glNo4 + accountCode.glNo5;

    if (!glNo || glNo.length !== 6) {
      await showGlobalOkDialog(<p> * Please fill out the [Account Code] (Fixed Length : 6 )</p>);
      return false;
    }
    if (!accountCode.glDescription) {
      await showGlobalOkDialog(<p> * Please fill out the [Account Name] </p>);
      return false;
    }
    if (['I', 'C'].indexOf(accountCode.glType) >= 0 && !accountCode.otherGlDesc) {
      await showGlobalOkDialog(<p> * Please fill out the {accountCode.glType === 'I' ? 'Cost' : 'Sales'} [Account Name] </p>);
      return false;
    }

    if (await appContext.api.checkupDuplicateFieldValueIsDuplicate("T_CODEGLNO", "F_GLNO", glNo, "F_ID", accountCode.id)) {
      await showGlobalOkDialog(<p> * Duplicate Number in [Account Code]</p>);
      return false;
    }
    return true;
  }

  async function save() {
    if (!accountCode) {
      return;
    }

    if (!accountCodeRef.current?.isDirty) {
      cancelOperation();
      await reload();
      return;
    }

    const isDataValid = await checkDataAsync();
    if (!isDataValid) {
      return;
    }

    saveAccountCode();

    let sqlInfo: SQLInfo | null;
    const sqlInfoList: SQLInfo[] = [];

    sqlInfo = historyUpdate("T_CODEGLNO", accountCode.id, appContext.user?.id ?? '', accountCode.inactive ? "Inactive" : "Active");
    if (sqlInfo) {
      sqlInfoList.push(sqlInfo);
    }
    const sqlInfos = getSQLInfoList(accountCode as TrackableEntity);
    sqlInfoList.push(...sqlInfos);

    //Type이 I나 C일때 다른 데이터도 저장할 필요가 있음
    if (['I', 'C'].indexOf(accountCode.glType) >= 0) {
      if (accountCode.otherId === 0) {      //Insert
        sqlInfoList.push(new SQLInfo({
          type: SQLType.Insert,
          tableName: 'T_CODEGLNO',
          key: new SQLField({ fieldName: 'F_ID', propertyName: 'id', value: -1 }),
          fields: [
            new SQLField({ fieldName: 'F_GlNo', propertyName: 'glNo', value: accountCode.otehrGlno }),
            new SQLField({ fieldName: 'F_GlType', propertyName: 'glType', value: accountCode.glType === 'I' ? 'C' : 'I' }),
            new SQLField({ fieldName: 'F_GlGroup', propertyName: 'glGroup', value: accountCode.glGroup.substring(0, 1) + (accountCode.glType === 'I' ? 'C' : 'I') }),
            new SQLField({ fieldName: 'F_GlSubGroup', propertyName: 'glSubGroup', value: accountCode.glSubGroup }),
            new SQLField({ fieldName: 'F_GlDescription', propertyName: 'glDescription', value: accountCode.otherGlDesc }),
            new SQLField({ fieldName: 'F_LocalDesc', propertyName: 'localDesc', value: accountCode.otherLocalDesc }),
            new SQLField({ fieldName: 'F_Remark', propertyName: 'remark', value: accountCode.otherRemark ?? '' }),
            new SQLField({ fieldName: 'F_Inactive', propertyName: 'inactive', value: accountCode.inactive }),
            new SQLField({ fieldName: 'F_InactiveDate', propertyName: 'inactiveDate', value: _.isEmpty(accountCode.inactiveDate) ? null : accountCode.inactiveDate }),
            new SQLField({ fieldName: 'InactiveBy', propertyName: 'inactiveBy', value: accountCode.inactiveBy ?? '' }),
            new SQLField({ fieldName: 'F_UseOnBillPay', propertyName: 'useOnBillPay', value: accountCode.useOnBillPay}),
            new SQLField({ fieldName: 'F_UseOnCustPay', propertyName: 'useOnCustPay', value: accountCode.useOnCustPay}),
          ]
        }));
      } else { //Update
        sqlInfoList.push(new SQLInfo({
          tableName: "T_CODEGLNO",
          type: SQLType.Update,
          fields: [
            new SQLField({ fieldName: 'F_GlNo', propertyName: 'glNo', value: accountCode.otehrGlno }),
            new SQLField({ fieldName: 'F_GlType', propertyName: 'glType', value: accountCode.glType === 'I' ? 'C' : 'I' }),
            new SQLField({ fieldName: 'F_GlGroup', propertyName: 'glGroup', value: accountCode.glGroup.substring(0, 1) + (accountCode.glType === 'I' ? 'C' : 'I') }),
            new SQLField({ fieldName: 'F_GlSubGroup', propertyName: 'glSubGroup', value: accountCode.glSubGroup }),
            new SQLField({ fieldName: 'F_GlDescription', propertyName: 'glDescription', value: accountCode.otherGlDesc }),
            new SQLField({ fieldName: 'F_LocalDesc', propertyName: 'localDesc', value: accountCode.otherLocalDesc }),
            new SQLField({ fieldName: 'F_Remark', propertyName: 'remark', value: accountCode.otherRemark ?? '' }),
            new SQLField({ fieldName: 'F_Inactive', propertyName: 'inactive', value: accountCode.inactive }),
            new SQLField({ fieldName: 'F_InactiveDate', propertyName: 'inactiveDate', value: _.isEmpty(accountCode.inactiveDate) ? null : accountCode.inactiveDate }),
            new SQLField({ fieldName: 'InactiveBy', propertyName: 'inactiveBy', value: accountCode.inactiveBy ?? '' }),
            new SQLField({ fieldName: 'F_UseOnBillPay', propertyName: 'useOnBillPay', value: accountCode.useOnBillPay}),
            new SQLField({ fieldName: 'F_UseOnCustPay', propertyName: 'useOnCustPay', value: accountCode.useOnCustPay}),
          ],
          key: new SQLField({ fieldName: "F_ID", propertyName: "id", value: accountCode.otherId }),
        }));
      }
    }

    const isSuspenseCode = accountCode.glNo === fmsGlobal.SuspensePay || accountCode.glNo === fmsGlobal.SuspenseRcv;
    if ((accountCode.useOnBillPay || accountCode.useOnCustPay) && !isSuspenseCode) {
      const isAssetOrLiabilityCode = accountCode.glNo0 === '1' || accountCode.glNo0 === '2';
      const billPayOptionValue = isAssetOrLiabilityCode ? '' : (accountCode.useOnBillPay ? '1' : '');
      const custPayOptionValue = isAssetOrLiabilityCode ? '' : (accountCode.useOnCustPay ? '1' : '');

      sqlInfos.push(new SQLInfo({
        tableName: "T_CODEGLNO",
        type: SQLType.Update,
        fields: [
          new SQLField({ fieldName: "F_BillPayShowOption", propertyName: "billPayShowOption", value: billPayOptionValue }),
          new SQLField({ fieldName: "F_CustPayShowOption", propertyName: "custPayShowOption", value: custPayOptionValue }),
        ],
        key: new SQLField({ fieldName: "F_ID", propertyName: "id", value: accountCode.otherId })
      }));
    }

    const apiResult = await appContext.api.saveJobDetail(JobNames.GLNo, sqlInfoList, {});

    if (apiResult && apiResult.success) {
      if (accountCode.glType === 'I' || accountCode.glType === 'C') {
        const checkApiResult = await appContext.api.checkNonExistAcctCode(accountCode.glType, accountCode.glGroup, accountCode.glNo.substring(3));
        if (!!checkApiResult && !!checkApiResult.msg && checkApiResult.msg !== 'AllSaved') {
          const newForm = await showGlobalYesNoDialog(
            <div>
              <h3>The data has been saved</h3>
              <h3>Are you going to continue </h3>
              <h3>{checkApiResult.msg}</h3>
            </div>
          ,false, 0, true);
          if (!newForm) {
            cancelOperation();
            reload(false);
          } else {
            //const newModel = _.cloneDeep(accountCode);
            // newModel.glSubGroup = '';
            // newModel.remark = '';
            // newModel.otherRemark = '';
            // newModel.glNo2 = '';
            // newModel.existingCode = '';
            // newModel.otherExistingCode = '';

            const newModel = new CodeGlNo();
            newModel.glType = accountCode.glType;
            newModel.glGroup = accountCode.glGroup;
            newModel.glNo0 = accountCode.glNo0;
            newModel.glNo1 = accountCode.glNo1;
            newModel.glNo3 = accountCode.glNo3;
            newModel.glNo4 = accountCode.glNo4;
            newModel.glNo5 = accountCode.glNo5;

            newModel.displayDesc = accountCode.displayDesc;
            newModel.displayLocalDesc = accountCode.displayLocalDesc;
            newModel.otherdisplayDesc = accountCode.otherdisplayDesc;
            newModel.otherdisplayLocalDesc = accountCode.otherdisplayLocalDesc;

            newModel.glDescription = accountCode.glDescription;
            newModel.localDesc = accountCode.localDesc;
            newModel.otherGlDesc = accountCode.otherGlDesc;
            newModel.otherLocalDesc = accountCode.otherLocalDesc;

            newModel.edit = false;
            newModel.view = false;
            setAccountCode(newModel, false);
            setCleanState(newModel);

            if (accountCodeRef.current) {
              accountCodeRef.current.trackable = true;
              setAccountCode({
                edit: false,
                view: false,
              });
            }
            reload(false);
          }
        } else {
          await showGlobalOkDialog(<p>The data has been saved</p>);
          cancelOperation();
          reload(false);
        }
      }
      else {
        await showGlobalOkDialog(<p>The data has been saved</p>);
        cancelOperation();
        reload(false);
      }
    }
  }

  function saveAccountCode() {
    if (!accountCode) return;

    const mainChange: Partial<CodeGlNo> = {};

    mainChange.glNo = accountCode.glNo0 + accountCode.glNo1 + accountCode.glNo2 + accountCode.glNo3 + accountCode.glNo4 + accountCode.glNo5;
    if (accountCode.glType === 'I') { mainChange.otehrGlno = 6 + accountCode.glNo1 + accountCode.glNo2 + accountCode.glNo3 + accountCode.glNo4 + accountCode.glNo5; }
    else if (accountCode.glType === 'C') { mainChange.otehrGlno = 5 + accountCode.glNo1 + accountCode.glNo2 + accountCode.glNo3 + accountCode.glNo4 + accountCode.glNo5; }

    if (accountCode.frontGlDesc) {
      mainChange.glDescription = accountCode.frontGlDesc + accountCode.displayDesc;
      mainChange.otherGlDesc = accountCode.frontGlDesc.replace((accountCode.glType === 'I' ? "SALES" : "COST"), (accountCode.glType === 'I' ? "COST" : "SALES")) + accountCode.otherdisplayDesc;
      if (mainChange.glDescription.length > 100) {
        mainChange.glDescription = mainChange.glDescription.substring(0, 100);
        mainChange.otherGlDesc = mainChange.otherGlDesc.substring(0, 100);
      }
      mainChange.localDesc = accountCode.frontLocalDesc + accountCode.displayLocalDesc;
      mainChange.otherLocalDesc = accountCode.frontLocalDesc.replace((accountCode.glType === 'I' ? "SALES" : "COST"), (accountCode.glType === 'I' ? "COST" : "SALES")) + accountCode.otherdisplayLocalDesc;
      if (mainChange.localDesc.length > 50) {
        mainChange.localDesc = mainChange.localDesc.substring(0, 50);
        mainChange.otherLocalDesc = mainChange.otherLocalDesc.substring(0, 50);
      }
    } else {
      mainChange.glDescription = accountCode.displayDesc;
      mainChange.localDesc = accountCode.displayLocalDesc;
      if (!accountCode.displayLocalDesc) mainChange.localDesc = accountCode.displayDesc;
      if (mainChange.localDesc.length > 50) {
        mainChange.localDesc = mainChange.localDesc.substring(0, 50);
      }
    }
    if (!accountCode.edit) {
      let userDesc = moment(nowDate()).format('MM-DD-YYYY') + ' by ' + (appContext.user?.id ?? '');
      mainChange.remark = accountCode.remark === '' ? userDesc : (accountCode.remark + '\r\n' + userDesc);
      mainChange.otherRemark = accountCode.otherRemark === '' ? userDesc : (accountCode.otherRemark + '\r\n' + userDesc);
    }
    if (accountCode.edit && accountCode.otherId === 0) {
      let userDesc = moment(nowDate()).format('MM-DD-YYYY') + ' by ' + (appContext.user?.id ?? '');
      mainChange.otherRemark = accountCode.otherRemark === '' ? userDesc : (accountCode.otherRemark + '\r\n' + userDesc);
    }

    if (!_.isEmpty(mainChange)) {
      setAccountCode(mainChange);
    }
  }

  return (
    <div style={{height: checkSuntek ? '550px' : '460px'}}>
      <div style={{ display: 'flex', paddingBottom: '20px' }}>
        <div style={{ marginLeft: 'auto' }}></div>
        <div className="ifms-common-bar-element ifms-right-separator-light-gray">
          <div className="ifms-common-bar-element">
            &nbsp;
            {accountCode?.view && listSec?.grantEdit &&
              <PrimaryButton name='accountcode-detail-edit-button' size="regular" onClick={() => setAccountCode({ view: false }, true)}>Edit</PrimaryButton>
            }
            {!accountCode?.view &&
              <GreenButton name='accountcode-detail-save-button' size="regular" onClick={save}>Save</GreenButton>
            }
            &nbsp;
          </div>
        </div>&nbsp;&nbsp;
        <div className="ifms-common-bar-element">
          <CloseButton name='accountcode-detail-close-button' onClick={cancelOperation} />
        </div>
      </div>
      <AccountCodeInitializedImpl
        accountCode={accountCodeT}
        onChange={setAccountCode}
        cancelOperation={cancelOperation}
        readonly={accountCodeT.view}
        save={save}
        getFrontDesc={getFrontDesc}
      />
      <div style={{ clear: 'both' }}></div>
    </div>
  );
}

export default AccountCodeDetails;
